import { createRoute } from '@tanstack/react-router';

import { billingPageLoadable } from 'pages/billing-page';

import { AuthenticatedRoute } from '../authenticated-route';

export const BillingRoute = createRoute({
  getParentRoute: () => AuthenticatedRoute,
  path: '/billing',
  component: billingPageLoadable,
});
